import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TopHeader } from '../components/layout/TopHeader';
import { ToastHost } from '../components/common/ToastHost';
import { PostAuthRouteValidator } from '../rbac/guards';

/** Extranet-parity shell for case-request routes (header only, no side nav). */
export function CaseRequestAppShell() {
  const { t, i18n } = useTranslation();

  return (
    <div className="app-full">
      <PostAuthRouteValidator />
      <TopHeader subtitle={t('header.intranetPortal')} />
      <ToastHost />
      <main className="mc" role="main">
        <Outlet key={i18n.language} />
      </main>
    </div>
  );
}
